import type { MessageKey } from './en';

/** Core gameplay strings; anything missing falls back to English. Needs native-speaker review. */
export const mr: Partial<Record<MessageKey, string>> = {
  'app.name': 'मेंडीकोट',
  'app.tagline': 'दश्यांचा क्लासिक भारतीय खेळ',
  'common.cancel': 'रद्द करा',
  'common.close': 'बंद करा',
  'common.back': 'मागे',
  'common.continue': 'पुढे चला',
  'common.loading': 'लोड होत आहे…',

  'home.greeting': 'नमस्कार, {{name}}',
  'home.playFriends': 'मित्रांसोबत खेळा',
  'home.playFriendsDesc': 'खाजगी टेबल · कोडने बोलवा',
  'home.practice': 'बॉट्ससोबत सराव',
  'home.practiceDesc': 'ऑफलाइन · तुमच्या गतीने',
  'home.join': 'कोडने सामील व्हा',
  'home.howTo': 'कसे खेळायचे',

  'create.title': 'टेबल तयार करा',
  'create.players': 'खेळाडू',
  'create.trump': 'हुकूम',
  'create.trump.CUT': 'कट (काटे)',
  'create.trump.BAND_A_AUTO': 'बंद हुकूम',
  'create.create': 'टेबल बनवा',
  'create.deal': 'पत्ते वाटा',
  'create.name': 'तुमचे नाव',

  'join.title': 'टेबलमध्ये सामील व्हा',
  'join.code': 'रूम कोड',
  'join.submit': 'जागा घ्या',

  'lobby.share': 'मित्रांना बोलवा',
  'lobby.copy': 'लिंक कॉपी करा',
  'lobby.waiting': 'खेळाडूंची वाट…',
  'lobby.ready': 'मी तयार आहे',
  'lobby.isReady': 'तयार',
  'lobby.start': 'सामना सुरू करा',
  'lobby.addBot': 'बॉट जोडा',
  'lobby.emptySeat': 'रिकामी जागा',
  'lobby.you': 'तुम्ही',
  'lobby.leave': 'टेबल सोडा',

  'table.yourTurn': 'तुमची पाळी',
  'table.waitingFor': '{{name}} विचार करत आहेत…',
  'table.trump': 'हुकूम',
  'table.trumpHidden': 'लपलेला',
  'table.trumpNone': 'ठरला नाही',
  'table.tens': 'दश्या',
  'table.tricks': 'हात',
  'table.you': 'तुम्ही',
  'table.partner': 'साथीदार',

  'result.win': 'तुमच्या संघाने डाव जिंकला!',
  'result.loss': 'हा डाव दुसऱ्या संघाचा',
  'result.coat': 'मेंडीकोट!',
  'result.whitewash': 'व्हाइटवॉश!',
  'result.next': 'पुढचा डाव',
  'result.seeMatch': 'सामन्याचा निकाल पहा',

  'match.won': 'सामना जिंकला!',
  'match.lost': 'सामना हरला',
  'match.rematch': 'पुन्हा खेळा',

  'suit.S': 'इस्पिक',
  'suit.H': 'बदाम',
  'suit.D': 'चौकट',
  'suit.C': 'किलवर',
  'team.us': 'आम्ही',
  'team.them': 'ते',

  'theme.diwali': 'दिवाळी',
  'theme.ganesh_chaturthi': 'गणेश चतुर्थी',
  'greeting.diwali': 'शुभ दीपावली! टेबल उजळवा.',
  'greeting.ganesh_chaturthi': 'गणपती बाप्पा मोरया!',

  'settings.analytics': 'वापर डेटा शेअर करा',
  'settings.privacy': 'गोपनीयता आणि डेटा',
  'settings.downloadData': 'माझा डेटा डाउनलोड करा',
  'settings.downloadDone': 'तुमची डेटा फाइल डाउनलोड होत आहे',
  'settings.privacyPolicy': 'गोपनीयता धोरण',
  'gate.title': 'खेळण्यापूर्वी',
  'gate.age': 'मेंडीकोट 18 वर्षे व त्याहून अधिक वयाच्या खेळाडूंसाठी आहे.',
  'gate.noticeIntro': 'आम्ही काय वापरतो, आणि का:',
  'gate.item.game':
    'एक गेस्ट आयडी, तुमचे टोपणनाव, अवतार आणि तुमचे डाव — तुमची टेबल चालवण्यासाठी आणि तुमची आकडेवारी ठेवण्यासाठी.',
  'gate.item.account':
    'तुमचा ईमेल किंवा Google नाव — फक्त तुम्ही तुमची प्रगती जतन करण्यासाठी साइन इन केल्यास.',
  'gate.item.push': 'एक सूचना टोकन — फक्त तुम्ही रिमाइंडर सुरू केल्यास.',
  'gate.item.security': 'Google reCAPTCHA द्वारे सुरक्षा तपासणी — बॉट्सना दूर ठेवण्यासाठी.',
  'gate.item.analytics':
    'वापर, परफॉर्मन्स आणि क्रॅश डेटा, एका रँडम आयडीशी जोडलेला, तुमचे नाव किंवा ईमेल कधीच नाही — फक्त तुमच्या परवानगीने.',
  'gate.rights': 'सेटिंग्जमध्ये कधीही तुमचा डेटा डाउनलोड करा किंवा हटवा, आणि तुमची निवड बदला.',
  'gate.policy': 'गोपनीयता धोरण',
  'gate.playShare': 'मी 18+ आहे · वापर डेटाला परवानगी द्या',
  'gate.playNoShare': 'मी 18+ आहे · शेअर करू नका',
  'gate.under18': 'माझे वय 18 पेक्षा कमी आहे',
  'gate.blockedTitle': 'क्षमस्व, तुमचे वय 18 असणे आवश्यक आहे',
  'gate.blockedBody': 'मेंडीकोट फक्त 18 वर्षे व त्याहून अधिक वयाच्या खेळाडूंसाठी आहे.',
  'gate.blockedBack': 'माझी चूक झाली',
  'privacy.title': 'गोपनीयता धोरण',
  'privacy.languageNote':
    'हे धोरण इंग्रजीमध्ये आहे. मराठी, हिंदी, गुजराती किंवा इतर भारतीय भाषेतील प्रतीसाठी आम्हाला ईमेल करा.',
};
